import React from 'react';
import ReactQuill from 'react-quill-new';
import 'react-quill-new/dist/quill.snow.css';

const quillModules = {
  toolbar: [
    [{ header: [1, 2, 3, 4, false] }],
    [{ font: [] }],
    [{ size: ['small', false, 'large', 'huge'] }],
    ['bold', 'italic', 'underline', 'strike'],
    [{ color: [] }, { background: [] }],
    [{ list: 'ordered' }, { list: 'bullet' }],
    [{ align: [] }],
    ['link'],
    ['clean'],
  ],
};

const quillFormats = [
  'header', 'font', 'size',
  'bold', 'italic', 'underline', 'strike',
  'color', 'background',
  'list', 'align',
  'link',
];

// Quill stores "<p><br></p>" when editor is visually empty
const isDescriptionEmpty = (val) => {
  if (!val) return true;
  // Remove HTML tags and check if anything remains
  const stripped = val.replace(/<[^>]*>/g, '').trim();
  return stripped === '';
};

const Step2 = ({ setCurrentStep, formData, setFormData }) => {
  const empty = isDescriptionEmpty(formData.description);


  return (
    <div className="bg-white dark:bg-[#191c22] p-6 rounded-lg shadow-md border dark:border-[#32353c] transition-colors duration-200">
      <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
        Gig Description <span className="text-red-500">*</span>
      </label>
      <p className="text-xs text-gray-400 dark:text-gray-500 mb-3">Required — describe what the client will receive in detail.</p>

      <ReactQuill
        theme="snow"
        value={formData.description}
        onChange={(value) => setFormData(prev => ({ ...prev, description: value }))}
        modules={quillModules}
        formats={quillFormats}
        placeholder="Describe your gig in detail..."
        style={{ minHeight: '280px', marginBottom: '16px' }}
      />

      {empty && (
        <p className="mt-2 text-red-500 text-sm flex items-center gap-1">
          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 9v2m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
          Description is required before proceeding.
        </p>
      )}

      {/* Action Buttons */}
      <div className="mt-16 flex justify-between">
        <button
          className="px-6 py-2 bg-gray-200 dark:bg-[#1d2026] text-gray-800 dark:text-white hover:bg-gray-300 dark:hover:bg-[#32353c] rounded-md flex items-center transition-colors"
          onClick={() => setCurrentStep(1)}
        >
          <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M10 19l-7-7m0 0l7-7m-7 7h18" />
          </svg>
          Back
        </button>

        <button
          className={`px-6 py-2 rounded-md flex items-center transition-colors ${
            empty
              ? 'bg-gray-300 dark:bg-[#0b0e14] text-gray-500 dark:text-gray-600 cursor-not-allowed border dark:border-[#32353c]'
              : 'bg-[#4B718F] dark:bg-blue-600 text-white hover:bg-gray-800 dark:hover:bg-blue-700'
          }`}
          onClick={() => { if (!empty) setCurrentStep(3); }}
          disabled={empty}
        >
          Proceed
          <svg className="w-5 h-5 ml-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M14 5l7 7m0 0l-7 7m7-7H3" />
          </svg>
        </button>
      </div>
    </div>
  );
};

export default Step2;